import { gql } from '@apollo/client';
import PATIENT_FRAGMENT from '../fragments/patientFragment';
import PATIENT_ONBOARDING_FRAGMENT from '../fragments/patientOnBoardingFragment';
import DIAGNOSIS_FRAGMENT from '../fragments/diagnosisFragment';
import INSURANCE_FRAGMENT from '../fragments/insuranceFragment';

const STUDY_PATIENT_INFO_QUERY = gql`
  query studyPatientInfo($id: ID!) {
    study(id: $id) {
      id
      onboarding {
        ...PatientOnBoardingFragment
      }
      info {
        patient {
          ...PatientFragment
        }
        diagnosis {
          ...DiagnosisFragment
        }
        insurance {
          ...InsuranceFragment
        }
        interprettingPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
        referringPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
      }
    }
  }

  ${PATIENT_FRAGMENT}
  ${PATIENT_ONBOARDING_FRAGMENT}
  ${DIAGNOSIS_FRAGMENT}
  ${INSURANCE_FRAGMENT}
`;

export default STUDY_PATIENT_INFO_QUERY;
